import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import 'progress_bar.scss';

/*
 * @param {string} headerId - The id of the header to calculate the offset height
 * @returns {string} - The offset height of the header for the progress bar to be positioned
 */
const calculateHeaderOffsetHeight = headerId => {
  if (!headerId) return null;

  const header = document.querySelector(headerId);
  const headerHeight = header?.offsetHeight || 0;
  return headerHeight - 1;
};

const ProgressBar = ({ percentage, classes, headerId }) => {
  const [topHeight, setTopHeight] = useState(() => calculateHeaderOffsetHeight(headerId));

  useEffect(() => {
    const handleWindowResize = () => {
      setTopHeight(calculateHeaderOffsetHeight(headerId));
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={['progress-bar', ...classes].join(' ')} style={{ top: topHeight }}>
      <div className="progress-bar-fill" style={{ width: `${percentage}%` }} />
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
  classes: PropTypes.arrayOf(PropTypes.string),
  headerId: PropTypes.string,
};

ProgressBar.defaultProps = {
  classes: [],
  headerId: undefined,
};

export default ProgressBar;
